import { Component, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { CartStore } from '@shared/services/shopping-cart/cart-store.service';
import { NttBadge } from '@ui/badge';
import { BottomNavLink } from './bottom-nav.model';

@Component({
  selector: 'bcm-bottom-nav',
  imports: [RouterLink, RouterLinkActive, NttBadge],
  templateUrl: './bottom-nav.html',
  styleUrl: './bottom-nav.scss',
})
export class BottomNavComponent {
  private readonly _cart = inject(CartStore);

  protected readonly itemCount = this._cart.itemCount;

  protected readonly links: BottomNavLink[] = [
    { label: 'خانه', route: '/dashboard', exact: true },
    { label: 'خرید گیفت کارت', route: '/categories' },
    { label: 'سبد خرید', route: '/basket' },
    { label: 'سفارشات من', route: '/orders' },
  ];
}
